import React from "react";
import { Link } from "react-router-dom";
import symbol from "../images/law.png";
import { useLang } from "../LanguageContext";

function Imprint() {
  const { t } = useLang();
  return (
    <div className="imprint">

      <div className="page-section-header">
        <span className="section-label">{t("imprint.label")}</span>
        <div className="subhead">{t("imprint.title")}</div>
      </div>

      <div className="imp-infos">
        <Link to="/licenses" className="link" style={{display:"inline-block", marginBottom:"1.25rem", fontWeight:700}}>
          {t("imprint.licensesLink")}
        </Link>
        <p className="sub2head">Angaben gemäß § 5 TMG</p>
        <table>
          <tbody>
            <tr>
              <td className="col1"><span>Verantwortlich:</span></td>
              <td>Dipl. Ing. (FH) Kai Steuernagel</td>
            </tr>
            <tr><td></td><td>Richard-Wimmer-Str. 15a</td></tr>
            <tr><td></td><td>63150 Heusenstamm</td></tr>
            <tr><td></td><td>(Germany)</td></tr>
            <tr>
              <td><span>Kontakt:</span></td>
              <td></td>
            </tr>
            <tr>
              <td><span>e-mail:</span></td>
              <td>
                k[at]steuernagel[dot]net
                <br />
                <span className="note">(Spam-safe notation)</span>
              </td>
            </tr>
          </tbody>
        </table>
        <div className="imp-icon">
          <img className="largeparagraph" src={symbol} alt="paragraph" />
        </div>
      </div>

      <div className="imp-legal">
        <div className="sub2head">Rechtliche Hinweise</div>
        <p>
          <span className="sub3head">Haftungsbeschränkung für eigene Inhalte</span>
          <span className="text">
            Alle Inhalte unseres Internetauftritts wurden mit Sorgfalt und nach
            bestem Gewissen erstellt. Eine Gewähr für die Aktualität,
            Vollständigkeit und Richtigkeit sämtlicher Seiten kann jedoch nicht
            übernommen werden. Gemäß § 7 Abs. 1 TMG sind wir als Dienstanbieter
            für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
            verantwortlich, nach den §§ 8 bis 10 TMG jedoch nicht verpflichtet,
            die übermittelten oder gespeicherten fremden Informationen zu
            überwachen. Eine umgehende Entfernung dieser Inhalte erfolgt ab dem
            Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung.
          </span>
          <span className="sub3head">Haftungsbeschränkung für externe Links</span>
          <span className="text">
            Unsere Webseite enthält sog. „externe Links" (Verknüpfungen zu
            Webseiten Dritter), auf deren Inhalt wir keinen Einfluss haben und
            für den wir aus diesem Grund keine Gewähr übernehmen. Für die
            Inhalte und Richtigkeit der Informationen ist der jeweilige
            Informationsanbieter der verlinkten Webseite verantwortlich.
          </span>
          <span className="sub3head">Urheberrecht</span>
          <span className="text">
            Die auf dieser Webseite veröffentlichten Inhalte und Werke
            unterliegen dem deutschen Urheberrecht. Jede Art der
            Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
            Verwertung außerhalb der Grenzen des Urheberrechts bedarf der
            vorherigen schriftlichen Zustimmung des jeweiligen Urhebers.
          </span>
          <span className="sub3head">Datenschutz</span>
          <span className="text">
            Durch den Besuch unseres Internetauftritts können Informationen über
            den Zugriff (Datum, Uhrzeit, aufgerufene Seite) auf dem Server
            gespeichert werden. Dies stellt keine Auswertung personenbezogener
            Daten dar. Sofern personenbezogene Daten erhoben werden, erfolgt
            dies nur mit dem vorherigen Einverständnis des Nutzers.
          </span>
        </p>
        <br />
        <div className="sub2head">Disclaimer</div>
        <p>
          <span className="sub3head">Limitation of liability for internal content</span>
          <span className="text">
            The content of our website has been compiled with meticulous care
            and to the best of our knowledge. However, we cannot assume any
            liability for the up-to-dateness, completeness or accuracy of any
            of the pages.
          </span>
          <span className="sub3head">Limitation of liability for external links</span>
          <span className="text">
            Our website contains links to the websites of third parties
            ("external links"). As the content of these websites is not under
            our control, we cannot assume any liability for such external content.
          </span>
          <span className="sub3head">Copyright</span>
          <span className="text">
            The content and works published on this website are governed by the
            copyright laws of Germany. Any duplication, processing, distribution
            or any form of utilisation beyond the scope of copyright law shall
            require the prior written consent of the author.
          </span>
          <span className="sub3head">Data protection</span>
          <span className="text">
            A visit to our website can result in the storage on our server of
            information about the access (date, time, page accessed). This does
            not represent any analysis of personal data. We cannot assume any
            liability for damages arising as a result of such security
            vulnerabilities.
          </span>
          <span className="reference">
            Source:{" "}
            <a
              className="link"
              href="http://www.mustervorlage.net/disclaimer-muster"
              target="_blank"
              rel="noreferrer"
            >
              Disclaimer on Mustervorlage.net
            </a>
          </span>
        </p>
      </div>

    </div>
  );
}

export default Imprint;
